<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12>
          <v-layout row wrap>
            <v-flex lg2 md2 sm12 pr-6 pl-lg-6>
              <v-layout row wrap justify-end>
                <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                  max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="computedStartDateFormatted" label="Từ ngày" hint="DD-MM-YYYY" persistent-hint
                      prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                </v-menu>
              </v-layout>
            </v-flex>
            <v-flex lg2 md2 sm12 pr-6>
              <v-layout row wrap justify-end>
                <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                  max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="computedEndDateFormatted" label="Đến ngày" hint="DD-MM-YYYY" persistent-hint
                      prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                </v-menu>
              </v-layout>
            </v-flex>
            <v-flex lg2 md2 sm12 pr-6 pt-0 v-if="pamentRole || adminRole">
              <v-select label="Thống kê theo" :items="StaffTypes" v-model="staffType" item-text="name"
                item-value="value"></v-select>
            </v-flex>
            <v-flex lg2 md2 sm12 pr-6 pt-0 v-if="pamentRole || adminRole">
              <v-select label="Nhân viên" :items="staffType == 'buyer' ? p_staffs : cs_staffs" v-model="staffID"
                item-text="Username" item-value="ID" clearable></v-select>
            </v-flex>
            <v-flex lg3 md3 sm12 pr-6>
              <v-btn @click="filter_data" color="#001650" outlined>Xem</v-btn>
              <v-btn @click="exportReport" color="#001650" outlined class="ml-2">Xuất file</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex lg12>
          <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows"
            :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.StaffName }}</td>
                <td>{{ item.OrderID }}</td>
                <td class="text-end">{{ item.TotalPrice | currency }}</td>
                <td class="text-end">{{ item.TotalRealAmount | currency }}</td>
                <td class="text-end">{{ item.FeeBuyAmount | currency }}</td>
                <td class="text-end">{{ item.TotalRevenue | currency }}</td>
                <td class="text-end">{{ item.TotalCommission | currency }}</td>
              </tr>
            </template>
            <template v-slot:body.append v-if="summary">
              <tr>
                <td class="font-weight-bold" colspan="2">TỔNG</td>
                <td class="text-end font-weight-bold">{{ summary.TotalPrice | currency }}</td>
                <td class="text-end font-weight-bold">{{ summary.TotalRealAmount | currency }}</td>
                <td class="text-end font-weight-bold">{{ summary.TotalFeeBuyAmount | currency }}</td>
                <td class="text-end font-weight-bold">{{ summary.TotalRevenue | currency }}</td>
                <td class="text-end font-weight-bold">{{ summary.TotalCommission | currency }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    return {
      headers: [
        {
          text: "Nhân viên",
          value: "StaffName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã đơn hàng",
          value: "OrderID",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền hàng",
          value: "TotalPrice",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền mua thật",
          value: "TotalRealAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí dịch vụ",
          value: "FeeBuyAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Doanh thu",
          value: "TotalRevenue",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Hoa hồng",
          value: "TotalCommission",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"] },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "thong-ke-hoa-hong-nhan-vien",
      dateRange: {
        startDate: moment
          .utc(Date.now())
          .startOf("month")
          .toISOString()
          .substr(0, 10),
        endDate: moment
          .utc(Date.now())
          .endOf("month")
          .toISOString()
          .substr(0, 10)
      },
      menuStart: false,
      menuEnd: false,
      order_type_list: configs.ORDER_TYPE_LIST,
      staffType: 'buyer',
      StaffTypes: [
        { name: "Mua hàng", value: 'buyer' },
        { name: "Kinh doanh", value: 'cs' }
      ],
      staffID: 0
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        this.filter_data();
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      items: state => state.report.commissionReport.data,
      total_rows: state => state.report.commissionReport.total,
      summary: state => state.report.commissionReport.summary,
      loading: state => state.report.loading,
      cs_staffs: state =>
        _.filter(state.commons.all_users, function (o) {
          return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        }),
      p_staffs: state =>
        _.filter(state.commons.all_users, function (o) {
          return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        })
    }),
    computedStartDateFormatted() {
      return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
    },
    computedEndDateFormatted() {
      return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    pamentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    }
  },
  methods: {
    filter_data: _.debounce(function () {
      var param = {
        pagination: this.pagination,
        startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
        endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
        staffType: this.staffType,
        staffID: this.staffID
      };
      this.$store.dispatch("report/getCommissionReport", param);
    }, 300, {
      'leading': true,
      'trailing': false
    }),
    exportReport() {
      var param = {
        startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
        endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
        staffType: this.staffType,
        staffID: this.staffID
      };
      this.$store.dispatch("report/exportCommissionReport", param);
    }
  },
  mounted() {
    this.$store.dispatch("commons/getAllUsers");
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>